<template>
  <div class="product-details-content-setup-step-04">
    <snow-input
      v-model="control.form.description"
      id="description"
      label="Descrição (Opcional)"
      type="textarea"
      info=" Essa descrição aparece no topo explicando como funciona o suporte."
      :errors="control.errors.description"
      rows="5"
    />
    <snow-input
      v-model="control.form.phone"
      :errors="control.errors.phone"
      type="tel"
      id="phone"
      mask="(##) #####-####"
      label="Telefone (opcional)"
    />

    <snow-input
      v-model="control.form.email"
      :errors="control.errors.email"
      type="email"
      id="email"
      label="E-mail (opcional)"
    />

    <snow-input
      v-model="control.form.link_chat_whatsapp"
      :errors="control.errors.link_chat_whatsapp"
      id="link_chat_whatsapp"
      label="Link para Chat do Whatsapp (Opcional)"
      info="O aluno será redirecionado para este link"
    />

    <snow-input
      v-model="control.form.opening_hours"
      id="opening_hours"
      label="Horário de atendimento (opcional)"
      textarea
      :errors="control.errors.opening_hours"
      rows="5"
    />
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
import get from "lodash/get";
export default {
  props: ["form"],
  data() {
    return {
      control: formFields(
        [
          "description",
          "phone",
          "email",
          "link_chat_whatsapp",
          "opening_hours"
        ],
        {
          ...get(this.form, "metadata_support", {})
        }
      )
    };
  },
  watch: {
    "form.metadata_support"(v) {
      this.control.form = { ...v };
    },
    control: {
      deep: true,
      handler(val) {
        for (let k in val.form) {
          this.form.metadata_support[k] = val.form[k];
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.product-details-content-setup-step-04 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
